import React, { useContext, useState } from "react";
import jwt_decode from "jwt-decode";
import { useNavigate, Link } from "react-router-dom";
import {
  Container,
  CardContent,
  Grid,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Box
} from "@mui/material";
import { UserContext } from "../UserContext";
import ErrorPage from "../components/ErrorPage";
import LoginApi from "../api/LoginApi";
import './LoginForm.css';
import CampaignIcon from '@mui/icons-material/Campaign';
import CategoryIcon from '@mui/icons-material/Category';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import SettingsIcon from '@mui/icons-material/Settings';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';

const LoginForm = () => {
  const {
    isLoggedIn,
    setIsLoggedIn,
    setUserToken,
    setRefresh_token,
    setRole,
    setRememberMeValue,
  } = useContext(UserContext);
  const [isError, setIsError] = useState(false);
  const [message, setMessage] = useState(null);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false,
  });

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRememberMeClick = (e) => {
    setFormData({
      ...formData,
      rememberMe: e.target.checked,
    });
  };

  const getUserLocation = async () => {
    try {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          (error) => {
            reject(new Error("Unable to retrieve location. Please allow location access."));
          },
          { timeout: 10000 }
        );
      });
    } catch (error) {
      throw new Error("Geolocation error: " + error.message);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      let locationString = "Unknown location";
      try {
        const location = await getUserLocation();
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${location.latitude}&lon=${location.longitude}`,
          { headers: { "User-Agent": "EnquiryMaster/1.0" } }
        );
        if (!response.ok) throw new Error("Failed to fetch address");
        const addressData = await response.json();
        const addressComponents = addressData.display_name.split(", ");

        let area = "",
          locality = "",
          city = "",
          state = "",
          country = "";
        if (addressComponents.length >= 5) {
          area = addressComponents[0];
          locality = addressComponents[1];
          city = addressComponents[2];
          state = addressComponents[addressComponents.length - 2];
          country = addressComponents[addressComponents.length - 1];
        } else if (addressComponents.length === 4) {
          locality = addressComponents[0];
          city = addressComponents[1];
          state = addressComponents[2];
          country = addressComponents[3];
        }
        locationString = [area, locality, city, state, country].filter(Boolean).join(", ");
      } catch (locationError) {
        console.warn("Location retrieval failed:", locationError.message);
      }

      const loginSuccess = await LoginApi(
        { ...formData, location: locationString },
        setIsError,
        setMessage
      );
      if (loginSuccess) {
        setIsLoggedIn(true);
        setUserToken(loginSuccess.access);
        setRefresh_token(loginSuccess.refresh);
        const decodedToken = jwt_decode(loginSuccess.access);
        setRole(decodedToken.role);
        setRememberMeValue(formData.rememberMe);

        const storage = formData.rememberMe ? localStorage : sessionStorage;
        storage.setItem("userToken", loginSuccess.access);
        storage.setItem("refreshToken", loginSuccess.refresh);
        storage.setItem("isLoggedIn", "true");

        navigate("/Dashboard");
      } else {
        throw new Error("Login failed. Please check your credentials.");
      }
    } catch (error) {
      console.error("Login error:", error);
      setIsError(true);
      setMessage(error.message || "An error occurred. Please try again.");
    }
  };

  if (isLoggedIn) {
    navigate("/Dashboard");
    return null;
  }

  return (
    <form onSubmit={submitHandler}>
        <Grid container spacing={2} className="centered-grid-container">
          <Grid item md={6} className="first-grid-item">
            <img src="2.png" className="img-fluid" alt="Sample image" />
            <div className="small-card">
              <CampaignIcon sx={{fontSize:'30px', color:'#99b3d1'}}/>
            </div>
            <div className="card-row">
              <div className="small-card1">
                <CategoryIcon  sx={{fontSize:'30px', color:'#8cb09e'}}/>
              </div>
              <div className="small-card2">
                <SupportAgentIcon  sx={{fontSize:'30px', color:'#99b3d1'}}/>
              </div>
            </div>
              <img src="loginpage_img.png" className="img-fluid2" alt="Sample image" />
              <div className="card3-div">
              <div className="small-card3">
                <LocalPhoneIcon  sx={{fontSize:'30px', color:'#ffd8c2'}}/>
              </div>
              </div>
              <div className="card4-div">
              <div className="small-card4">
                <SettingsIcon  sx={{fontSize:'30px', color:'#ffd8c2'}}/>
              </div>
              </div>
              <div className="card5-div">
              <div className="small-card5">
                <TipsAndUpdatesIcon  sx={{fontSize:'30px', color:'#8cb09e'}}/>
              </div>
              </div>
              <div className="card6-div">
              <div className="small-card6">
                <HelpCenterIcon  sx={{fontSize:'30px', color:'#99b3d1'}}/>
              </div>
              </div>
          </Grid>
           <Grid item md={6} className="second-grid-item">
            <CardContent className="login-card">
               <img src="equip.png" className="equip-logo" alt="Sample image" />
              <Typography variant="h6" className="login-text-color" >
                Login in to Equip
              </Typography>
              <TextField
                className="custom-textfield"
                variant="outlined"
                fullWidth
                size="small"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                margin="normal"
              />
              <TextField
                className="custom-textfield"
                variant="outlined"
                fullWidth
                size="small"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                margin="normal"
              />

              <Grid container justifyContent="space-between" alignItems="center">
               <FormControlLabel
                  control={
                    <Checkbox
                      name="rememberMe"
                      checked={formData.rememberMe}
                      onChange={handleRememberMeClick}
                    />
                  }
                  label={
                    <Typography sx={{ color: '#fb7102', fontFamily: "'Josefin Sans', sans-serif !important" }}>
                      Remember Me
                    </Typography>
                  }
                />
                <Link to="/forgot-password" className="forgot-text" >Forgot password? </Link>
              </Grid>

              <Box className="button-box">
              <Button
                type="submit"
                className="custom-login-btn"
              >
                Login
              </Button>
              </Box>

              
            </CardContent>
          </Grid>
        </Grid>
      {isError && <ErrorPage message={message} />}
    </form>
  );
};

export default LoginForm;